import { breadcrumbSchema, clinicListSchema } from "../structured-data-core";
import { clinicsIn } from "../clinics";

// A hub page lists the clinics and links to each clinic's own page. The
// clinic nodes live on those pages, not here.
export function getWestStructuredData() {
  return [
    clinicListSchema("RESTORE Hair clinics in the West", "/locations/restore-west/", clinicsIn("denver")),
    breadcrumbSchema([
      { name: "Locations", path: "/locations/" },
      { name: "West", path: "/locations/restore-west/" },
    ]),
  ];
}
